<div class="container-fluid" *ngIf="checkDataExists">
    <fieldset class="border rounded-3 px-1">
        <legend class="float-none w-auto px-1 pb-2 font-size-13">{{'REVIEW_SOL_HOURS_TASKS_TAB.TITLE' |translate}}
        </legend>
        <div class="row">
            <div class="col-md-12">
                <table mat-table [dataSource]="dataSourceLevelWise" class="mat-elevation-z8 tableBorder">
                    <ng-container *ngFor="let column of hoursColumns" [matColumnDef]="column.field">
                        <th mat-header-cell *matHeaderCellDef [style.width]="column.colWidth" class="custom-header">
                            {{column.header | translate}}</th>
                        <td mat-cell *matCellDef="let element" mat-divider [class.right-align]="column.isRightAlign">
                            <ng-container *ngIf="column.field === 'notes'; else defaultCell">
                                <span [innerHTML]="truncateText(element[column.field], constants.FIFTY)"></span>
                                <ng-container *ngIf="element[column.field]?.length > constants.FIFTY">
                                    <mat-icon class="customIcon"
                                        (click)="openNotesDialog(element[column.field]); $event.stopPropagation();">
                                        more_horiz
                                    </mat-icon>
                                </ng-container>
                            </ng-container>
                            <ng-template #defaultCell>
                                {{ element[column.field] }}
                            </ng-template>

                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsLevelWise"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsLevelWise;"
                        (click)="onHourByLevelColumnClicked(row)" [class.highlighted]="selectedRow === row"></tr>
                </table>
                <ng-template #noDataTemplate>
                    <div class="no-data-message">{{'COMMON_LABELS.NO_DATA_FOUND' |translate}}</div>
                </ng-template>
                <div class="mb-2 levelwise-paginator-container addPaginatorStyle">
                    <label for="levelWisePageSize" class="me-2 addMargin">{{'REVIEW_SOL_HOURS_TASKS_TAB.ITEMS_PER_PAGE'
                        |translate}}:</label>
                    <input id="levelWisePageSize" type="number" min="constants.One" [value]="pageSizeLevelWise"
                        #pageSizeInput class="no-spinner custom-page-size-input"
                        (change)="reviewService.onPageSizeLevelWiseChange(pageSizeInput.value, levelPaginator,$event)">
                    <mat-paginator class="small-font-paginator" [pageSize]="pageSizeLevelWise"
                        showFirstLastButtons></mat-paginator>
                </div>

            </div>
        </div>
    </fieldset>
    <fieldset class="border rounded-3 pt-1 px-1">
        <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_HOURS_TASKS_TAB.TASK_BY_LEVEL' |translate}}
        </legend>
        <div>
            <table mat-table [dataSource]="dataSourceTaskByLevelWithNotes" class="mat-elevation-z8 tableBorder">
                <ng-container *ngFor="let column of taskColumns" [matColumnDef]="column.field">
                    <th mat-header-cell *matHeaderCellDef mat-divider class="align-center">
                        {{ column.header | translate}}</th>
                    <td mat-cell *matCellDef="let element" mat-divider [class.right-align]="column.isRightAlign">
                        {{ element[column.field] }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTasksWise; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTasksWise;">
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell no-data-message align-center" [attr.colspan]="displayedColumnsTasksWise.length">
                        {{'COMMON_LABELS.NO_DATA_FOUND' | translate}}</td>
                </tr>
            </table>
            <ng-template #noDataTemplate>
                <div class="no-data-message">{{'COMMON_LABELS.NO_DATA_FOUND' | translate}}</div>
            </ng-template>

            <div class="mb-2 levelwise-paginator-container addPaginatorStyle">
                <label for="taskWisePageSize" class="me-2 addMargin">{{'REVIEW_SOL_HOURS_TASKS_TAB.ITEMS_PER_PAGE'
                    |translate}}:</label>
                <input id="taskWisePageSize" type="number" min="constants.One" [value]="pageSizeLevelWise"
                    #pageSizeInput1 class="no-spinner custom-page-size-input"
                    (change)="reviewService.onPageSizeLevelWiseChange(pageSizeInput1.value, taskPaginator,$event)">
                <mat-paginator #taskPaginator class="small-font-paginator" [pageSize]="pageSizeLevelWise"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </fieldset>

    <fieldset class="border rounded-3 pt-1 px-1" *ngIf="hoursByLevelDetails.length">
        <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_HOURS_TASKS_TAB.CONDITION_BY_LEVEL'
            |translate}}</legend>
        <div>
            <table mat-table [dataSource]="dataSourceConditionWise" class="mat-elevation-z8 tableBorder">
                <ng-container *ngFor="let column of conditionColumns" [matColumnDef]="column.field">
                    <th mat-header-cell *matHeaderCellDef mat-divider class="align-center">
                        {{column.header | translate}}</th>
                    <td mat-cell *matCellDef="let element" mat-divider [class.right-align]="column.isRightAlign">
                        {{ element[column.field] }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsConditionWise; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsConditionWise;">
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell no-data-message align-center"
                        [attr.colspan]="displayedColumnsConditionWise.length">{{'COMMON_LABELS.NO_DATA_FOUND' |
                        translate}}</td>
                </tr>
            </table>
            <ng-template #noDataTemplate>
                <td class="mat-cell no-data-message align-center" [attr.colspan]="displayedColumnsConditionWise.length">
                    {{'COMMON_LABELS.NO_DATA_FOUND' |translate}}</td>
            </ng-template>
            <div class="mb-2 levelwise-paginator-container addPaginatorStyle">
                <label for="taskWisePageSize" class="me-2 addMargin">{{'REVIEW_SOL_HOURS_TASKS_TAB.ITEMS_PER_PAGE'
                    |translate}}:</label>
                <input id="taskWisePageSize" type="number" min="constants.One" [value]="pageSizeLevelWise"
                    #pageSizeInput2 class="no-spinner custom-page-size-input"
                    (change)="reviewService.onPageSizeLevelWiseChange(pageSizeInput2.value, conditionPaginator,$event)">
                <mat-paginator #conditionPaginator class="small-font-paginator" [pageSize]="pageSizeLevelWise"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </fieldset>

</div>
<div class="container-fluid customizeText" *ngIf="!checkDataExists">

    {{'REVIEW_SOL_HOURS_TASKS_TAB.HOURS_TASKS_DATA_NOT_FOUND' |translate}}

</div>